import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-178bd671"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "order_query"
};
var _hoisted_2 = ["src"];

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "个性定制", -1);
});

var _hoisted_4 = {
  style: {
    "margin": "16px"
  }
};

var _hoisted_5 = /*#__PURE__*/_createTextVNode(" 个性定制 ");

var _hoisted_6 = /*#__PURE__*/_createTextVNode("靓号中心");

var _hoisted_7 = /*#__PURE__*/_createTextVNode("个性定制");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_van_field = _resolveComponent("van-field");

  var _component_van_cell_group = _resolveComponent("van-cell-group");

  var _component_van_button = _resolveComponent("van-button");

  var _component_van_form = _resolveComponent("van-form");

  var _component_van_tabbar_item = _resolveComponent("van-tabbar-item");

  var _component_van_tabbar = _resolveComponent("van-tabbar");

  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("img", {
    src: require('../assets/images/order_big_tg.png')
  }, null, 8, _hoisted_2), _hoisted_3]), _createVNode(_component_van_form, {
    onSubmit: $options.submitCustomize
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_van_cell_group, {
        inset: ""
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_van_field, {
            modelValue: $data.userName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return $data.userName = $event;
            }),
            name: "用户名",
            label: "姓名",
            placeholder: "请填写购买人姓名",
            rules: [{
              required: true,
              message: '请填写姓名'
            }]
          }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
            modelValue: $data.phone,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
              return $data.phone = $event;
            }),
            type: "tel",
            name: "联系电话",
            label: "联系电话",
            placeholder: "请填写购买人联系电话",
            rules: [{
              required: true,
              message: '请填写联系电话'
            }]
          }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
            modelValue: $data.message,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
              return $data.message = $event;
            }),
            rows: "3",
            autosize: "",
            label: "留言",
            type: "textarea",
            maxlength: "120",
            placeholder: "我想要杭州尾号3个8的号码，预算800左右",
            "show-word-limit": ""
          }, null, 8, ["modelValue"])];
        }),
        _: 1
      }), _createElementVNode("div", _hoisted_4, [_createVNode(_component_van_button, {
        round: "",
        block: "",
        type: "primary",
        "native-type": "submit"
      }, {
        default: _withCtx(function () {
          return [_hoisted_5];
        }),
        _: 1
      })])];
    }),
    _: 1
  }, 8, ["onSubmit"]), _createVNode(_component_van_tabbar, {
    modelValue: $data.active,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
      return $data.active = $event;
    }),
    "active-color": "#ee0a24",
    "inactive-color": "#000"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_van_tabbar_item, {
        icon: "home-o",
        to: '/' + $data.source + $data.locationSearch
      }, {
        default: _withCtx(function () {
          return [_hoisted_6];
        }),
        _: 1
      }, 8, ["to"]), _createVNode(_component_van_tabbar_item, {
        icon: "search"
      }, {
        default: _withCtx(function () {
          return [_hoisted_7];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["modelValue"])]);
}